module.exports = __webpack_public_path__ + "img/symbol_8.52f291ee.png";